import React from 'react';
import { BaasicSelect, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ExportLabelsTemplate = ({
	exportLabelsViewStore: {
		loading,
		form,
		carrierServiceOptions,
		onCarrierServiceSelect,
		selectedCarrierService,
		exportLabels,
	},
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EXPORTLABELSMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicSelect
					field={form.$('carrierService')}
					clearable={false}
					options={carrierServiceOptions}
					onChange={onCarrierServiceSelect}
					value={selectedCarrierService}
					className="spc--bottom--sml flex--grow--1"
				/>
			</div>
			<div className="ReactModal__footer">
				<button
					type="button"
					className="btn btn--med btn--primary spc--bottom--sml"
					disabled={selectedCarrierService == null}
					onClick={exportLabels}
				>
					{t('CONFIRM')}
				</button>
			</div>
		</React.Fragment>
	);
};

export default defaultTemplate(ExportLabelsTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ExportLabelsTemplate.jsx